import * as React from 'react'
import {NavigationItem} from './sidebar'
import {NavLink} from "react-router-dom";
import './SideBarItem.scss';
import { RouteComponentProps, withRouter } from "react-router";
import {injectIntl, IntlShape} from 'react-intl'

interface IProps extends RouteComponentProps<any>{
    item: NavigationItem,
    rightList: string[],
    intl: IntlShape
}

interface IState {
    expand: boolean
}

class SideBarItem extends React.Component<IProps, IState> {
    constructor(props: IProps){
        super(props)
        // console.log(props)
        if(!props.item.children || !props.item.children.length){
            this.state = {
                expand: false
            }
        }else {
            let expand = false;
            for(var i in props.item.children){
                if(props.item.children[i].link === props.location.pathname){
                    expand = true;
                    break;
                }
            }
            this.state = {expand}
        }
    }

    private toggleExpand = () =>{
        this.setState({expand: !this.state.expand})
    }
    public render() {
        let {item, intl, ...rest} = this.props
        if(this.props.rightList[0] !== '*' && this.props.rightList.indexOf(item.id) === -1){
            return null
        }
        return (
            <div className="sideBarItem">
                {item.children && item.children.length ?
                    <span className="navLink" onClick={this.toggleExpand}>
                        <span className={`icon icon-${item.id}`}></span>
                        <span className="text">{intl.formatMessage({id: item.id})}</span>
                        <span className={`icon-arrow ${this.state.expand ? '':''}`}></span>
                    </span>
                    : item.link ?
                        <NavLink className="navLink" to={item.link}>
                            <span className={`icon icon-${item.id}`}></span>
                            <span className="text">{intl.formatMessage({id: item.id})}</span>
                        </NavLink> : null}
                {item.children && item.children.length ?
                    <div className={`children ${this.state.expand ? '' : 'hide'}`}>
                        {item.children.map((child: NavigationItem, index: number) => {
                            return <SideBarItem item={child} key={index} {...rest} intl={intl}/>
                        })}
                    </div>
                    : null}
            </div>
        );
    }
}

export default withRouter(injectIntl(SideBarItem));
